export const colors = {
    primary: "#266313",
    secondary: "#3DB319",
    white: "#fff",
    faint_text: "#667085",
    body_text: "#101828",
    link_color: "#2A870E",
    body_color: "#FCFCFD",
}

